import ThemeConstants from '../../../../theme/ThemeConstants';

const classes = {
  card: {
    display: 'flex',
    paddingTop: '22px',
    flex: 1,
  },

  zeroPadding: {
    paddingTop: 0,
  },

  autoRecords: {
    paddingTop: 1.5,
  },

  cardContent: {
    display: 'flex',
    flex: 1,
  },

  image: {
    height: '75px',
    width: '75px',
    border: `2px solid ${ThemeConstants.common.border}`,
  },

  rangeLabel: {
    my: '4px',
  },

  avatarContainer: {
    display: 'flex',
    position: 'relative',
  },

  favIconContainer: {
    position: 'absolute',
    top: 50,
    left: 50,
    zIndex: 1,
  },

  rightItem: {
    alignSelf: 'flex-start',
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    paddingTop: '3px',
  },

  infoContainer: {
    flex: 1,
    marginLeft: '16px',
  },

  gutter: {
    paddingBottom: '16px',
  },

  title: {
    fontWeight: 600,
    lineHeight: '30px',
    fontSize: '20px',
    color: 'common.grey850',
    marginRight: '10px',
  },

  addressText: {
    fontSize: '14px',
    fontWeight: 400,
    color: 'common.grey850',
  },

  date: {
    lineHeight: '21px',
    fontSize: '14px',
    fontWeight: 400,
    color: 'common.grey850',
  },

  timeChip: {
    marginTop: '10px',
  },

  footerContainer: {
    display: 'flex',
    flexDirection: 'row',
  },

  footerPart: {
    flex: 1,
    marginTop: '16px',
    justifyContent: 'center',
  },

  itemTitle: {
    paddingBottom: '4px',
    fontSize: '12px',
  },

  itemValue: {
    fontSize: '14px',
    fontWeight: 500,
  },

  counterValue: {
    fontWeight: 600,
  },

  strike: {
    textDecoration: 'line-through',
    paddingRight: '6px',
  },

  rightContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'flex-start',
  },

  chipContainer: {
    // marginBottom: '16px',
  },

  timeStrike: {
    textDecorationLine: 'line-through',
    fontSize: '14px',
    fontWeight: 400,
    color: 'common.grey850',
  },

  cardHover: {
    cursor: 'pointer',
  },

  locationContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  icon: {
    color: 'primary.main',
  },

  watchlistContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginLeft: 'auto',
    alignItems: 'flex-start',
  },

  location: {
    fontSize: 16,
    fontWeight: 600,
    color: 'common.grey850',
  },

  ratingText: {
    fontWeight: 500,
    fontSize: '14px',
    paddingLeft: '2px',
  },

  ratingContainer: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
  },

  customLink: {
    fontWeight: 500,
    fontSize: '14px',
    paddingLeft: '4px',
  },

  tagContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
};

export default classes;
